import { render, staticRenderFns } from "./CertificateIconExpired.vue?vue&type=template&id=69a4bd2d"
import script from "./CertificateIconExpired.vue?vue&type=script&lang=js"
export * from "./CertificateIconExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports